import React from "react";
import { Layout, Tooltip, Drawer } from "antd";
import {
  RobotOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

// Phase-1 (sq-ai standalone): the chat page is the only linked surface. Home was removed,
// so the nav carries a single item back to the chat. This sidebar only renders on the
// unlinked /usage route now.
const NAV = [
  {
    section: "SQ-AI",
    items: [
      { key: "/sq-ai", icon: <RobotOutlined />, label: "SQ-AI Agent" },
    ],
  },
];

export default function Sidebar({
  collapsed,
  onCollapse,
  asDrawer = false,
  drawerOpen = false,
  onDrawerClose = () => {},
}) {
  const navigate = useNavigate();
  const location = useLocation();

  // Inside the Drawer we always render expanded (the user explicitly opened it).
  const expanded = asDrawer ? true : !collapsed;

  const handleNavigate = (key) => {
    navigate(key);
    if (asDrawer) onDrawerClose();
  };

  const renderNavItem = (item) => {
    const isActive = location.pathname === item.key;
    const content = (
      <div
        key={item.key}
        className={`sidebar-nav-item${isActive ? " active" : ""}`}
        onClick={() => handleNavigate(item.key)}
      >
        <span className="nav-icon">{item.icon}</span>
        <span className="sidebar-nav-label">{item.label}</span>
      </div>
    );

    if (!expanded) {
      return (
        <Tooltip key={item.key} title={item.label} placement="right">
          {content}
        </Tooltip>
      );
    }
    return content;
  };

  const body = (
    <>
      <div className="sidebar-logo">
        <div className="sidebar-logo-icon">SQ</div>
        <span className="sidebar-logo-text">SafetyQube</span>
      </div>

      <div className="sidebar-nav">
        {NAV.map((section) => (
          <React.Fragment key={section.section}>
            <div className="sidebar-section-label">{section.section}</div>
            {section.items.map(renderNavItem)}
          </React.Fragment>
        ))}
      </div>

      {!asDrawer && (
        <div className="sidebar-toggle">
          <button onClick={() => onCollapse(!collapsed)}>
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </button>
        </div>
      )}
    </>
  );

  if (asDrawer) {
    return (
      <Drawer
        open={drawerOpen}
        onClose={onDrawerClose}
        placement="left"
        width={240}
        closable={false}
        styles={{ body: { padding: 0, background: "var(--color-sidebar-bg)" } }}
        className={`sidebar sidebar-drawer${expanded ? "" : " sidebar-collapsed"}`}
      >
        {body}
      </Drawer>
    );
  }

  return (
    <Layout.Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      width={240}
      collapsedWidth={68}
      className={`sidebar sidebar-sider${collapsed ? " sidebar-collapsed" : ""}`}
    >
      {body}
    </Layout.Sider>
  );
}
